module.exports = {
    "env": "dev",
    "api_base_url": "https://api.dev.tradly.app/",
    "auth_app_url": "https://auth.dev.tradly.app/",
    "portal_app_url": "https://portal.tradly.app/",
    "private_key": "f948cacf9adfcb578a753152db03bf8555f969e0",
    "internal_bearer_token": "lkv294e1f1ac6j5a361b4516c5elkczjz",
    "ck_private_key": "2ae86116e90f965c0e4d37376a0089cb76a61f99246faf2c95d13d3af7824977"
}
